import { render } from "./PDFPaginator.vue?vue&type=template&id=32bdc7d2"
import script from "./PDFPaginator.vue?vue&type=script&lang=js"
export * from "./PDFPaginator.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__